import type { Set } from '@/types/set';

/**
 * Sentinel ID used for the virtual "General" set, which represents
 * all moves that are not assigned to a real set.
 */
export const GENERAL_SET_ID = 'general';

/**
 * Synthetic Set object for the "General" virtual set.
 * Used in the set list and set detail views.
 */
export const GENERAL_SET: Set = {
  set_id: GENERAL_SET_ID,
  name: 'General',
  description: 'Moves that aren\'t part of a specific set',
  status: 'active',
  is_default: false,
  created_at: '',
  updated_at: '',
};
